<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-book-information-variant</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.infoTen') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
    </v-toolbar>

    <v-select
      v-model="selectedActividad"
      :items="actividades"
      item-text="name"
      item-value="id"
      label="Actividad"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="tiposFiltered && tiposFiltered.length > 1"
      v-model="selectedTipo"
      :items="tiposFiltered"
      item-text="name"
      item-value="id"
      label="Tipo"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="subtiposFiltered && subtiposFiltered.length > 1"
      v-model="selectedSubTipo"
      :items="subtiposFiltered"
      item-text="name"
      item-value="id"
      label="SubTipo"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="clasificacionTiposFiltered && clasificacionTiposFiltered.length > 1"
      v-model="selectedClasificacionTipo"
      :items="clasificacionTiposFiltered"
      item-text="name"
      item-value="id"
      label="ClasificacionTipo"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="subClasificacionTiposFiltered && subClasificacionTiposFiltered.length > 1"
      v-model="selectedSubClasificacionTipo"
      :items="subClasificacionTiposFiltered"
      item-text="name"
      item-value="id"
      label="SubClasificacionTipo"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="recomendados"
      v-model="selectedRecomendado"
      :items="recomendados"
      item-text="name"
      item-value="id"
      label="Recomendado"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="municipios"
      v-model="selectedMunicipio"
      :items="municipios"
      item-text="name"
      item-value="id"
      label="Municipio"
      @change="handleChangeFilters"
    />
    <v-select
      v-if="zonas"
      v-model="selectedZona"
      :items="zonas"
      item-text="name"
      item-value="id"
      label="Zona"
      @change="handleChangeFilters"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import Translate from '@/components/Translate'
  import CustomColorPicker from '@/components/CustomColorPicker'
  export default {
    components: {
      Translate,
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      selectedActividad: null,
      selectedTipo: null,
      selectedSubTipo: null,
      selectedClasificacionTipo: null,
      selectedSubClasificacionTipo: null,
      selectedRecomendado: null,
      selectedMunicipio: null,
      selectedZona: null,
      actividades: [],
      tipos: [],
      tiposFiltered: null,
      subtipos: [],
      subtiposFiltered: null,
      clasificacionTipos: [],
      clasificacionTiposFiltered: null,
      subClasificacionTipos: [],
      subClasificacionTiposFiltered: null,
      municipios: [],
      zonas: [],
      recomendados: [],
    }),
    computed: {
      ...mapState('app',['collapseContent']),
    },
    watch: {
      'selectedActividad' (v) {
        if (v) this.tiposFiltered = this.tipos.filter(x => x.actividad === v || x.actividad === null)
        this.selectedTipo = this.checkExist(this.tiposFiltered, 'Tipo')
      },
      'selectedTipo' (v) {
        this.subtiposFiltered = this.subtipos.filter(x => x.tipoActividad === v || x.tipoActividad === null)
        this.selectedSubTipo = this.checkExist(this.subtiposFiltered, 'SubTipo')
        this.clasificacionTiposFiltered = this.clasificacionTipos.filter(x => x.nombreTipo === v || x.nombreTipo === null)
        this.selectedClasificacionTipo = this.checkExist(this.clasificacionTiposFiltered, 'ClasificacionTipo')
      },
      'selectedSubTipo' (v) {
      },
      'selectedClasificacionTipo' (v) {
        this.subClasificacionTiposFiltered = this.subClasificacionTipos.filter(x => x.clasificacionTipo === v || x.clasificacionTipo === null)
        this.selectedSubClasificacionTipo = this.checkExist(this.subClasificacionTiposFiltered, 'SubClasificacionTipo')
      }
    },
    mounted () {
      if (typeof this.content.InfotenFilters === 'string') this.content.InfotenFilters = JSON.parse(this.content.InfotenFilters)
      this.getActividades()
    },
    methods: {
      checkExist(data, value) {
        const aux = this.content.InfotenFilters[value]
        if (aux && data.filter(x => x.id === aux).length > 0) return aux
        return null
      },
      prepareDataSaved () {
        this.selectedActividad = this.content.InfotenFilters.Actividad ? this.content.InfotenFilters.Actividad : 'Recursos'
        /*
        this.selectedTipo = this.content.InfotenFilters.Tipo ? this.content.InfotenFilters.Tipo : null
        this.selectedSubTipo = this.content.InfotenFilters.SubTipo ? this.content.InfotenFilters.SubTipo : null
        this.selectedClasificacionTipo = this.content.InfotenFilters.ClasificacionTipo ? this.content.InfotenFilters.ClasificacionTipo : null
        this.selectedSubClasificacionTipo = this.content.InfotenFilters.SubClasificacionTipo ? this.content.InfotenFilters.SubClasificacionTipo : null
        */
        this.selectedRecomendado = this.content.InfotenFilters.Recomendado ? this.content.InfotenFilters.Recomendado : null
        this.selectedMunicipio = this.content.InfotenFilters.Municipio ? this.content.InfotenFilters.Municipio : null
        this.selectedZona = this.content.InfotenFilters.Zona ? this.content.InfotenFilters.Zona : null
      },
      getActividades () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/actividades`)
          .then (response => {
            this.actividades = response.data.map (item => {
              return {
                id: item.nombre,
                name: item.nombre,
              }
            })
            this.getTipos()
          })
      },
      getTipos () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/tipos`)
          .then (response => {
            this.tipos = [{
              id: null,
              name: '',
              actividad: null,
            }]
            this.tipos.push(...response.data.filter(x => x.activo !== '0').map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
                actividad: item.actividad
              }
            }))
            this.getSubtipos()
          })
      },
      getSubtipos () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/subtipos`)
          .then (response => {
            this.subtipos = [{
              id: null,
              name: '',
              tipoActividad: null
            }]
            this.subtipos.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
                tipoActividad: item.TipoActividad
              }
            }))
            this.getClasificacionTipos ()
          })
      },
      getClasificacionTipos () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/clasificaciontipos`)
          .then (response => {
            this.clasificacionTipos = [{
              id: null,
              name: '',
              nombreTipo: null,
            }]
            this.clasificacionTipos.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
                nombreTipo: item.nombreTipo
              }
            }))
            this.getSubClasificacionTipos ()
          })
      },
      getSubClasificacionTipos () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/subclasificaciontipos`)
          .then (response => {
            this.subClasificacionTipos = [{
              id: null,
              name: '',
              clasificacionTipo: null
            }]
            this.subClasificacionTipos.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
                clasificacionTipo: item.ClasificacionTipo
              }
            }))
            this.getMunicipios()
          })
      },
      getMunicipios () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/municipios`)
          .then (response => {
            this.municipios = [{
              id: null,
              name: '',
              zona: null,
            }]
            this.municipios.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
                zona: item.zona,
              }
            }))
            this.getRecomendados()
          })
      },
      getRecomendados () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/recomendado`)
          .then (response => {
            this.recomendados = [{
              id: null,
              name: ''
            }]
            this.recomendados.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
              }
            }))
            this.getZonas()
          })
      },
      getZonas () {
        const url = process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3400/' : 'https://www.dtouch.es/'
        axios.get(`${url}public/infoten/zonas`)
          .then (response => {
            this.zonas = [{
              id: null,
              name: ''
            }]
            this.zonas.push(...response.data.map(item => {
              return {
                id: item.nombre,
                name: item.nombre,
              }
            }))
            this.prepareDataSaved()
          })
      },
      handleChangeFilters () {
        const filters = {}
        if (this.selectedActividad) filters.Actividad = this.selectedActividad
        if (this.selectedTipo) filters.Tipo = this.selectedTipo
        if (this.selectedSubTipo) filters.SubTipo = this.selectedSubTipo
        if (this.selectedClasificacionTipo) filters.ClasificacionTipo = this.selectedClasificacionTipo
        if (this.selectedSubClasificacionTipo) filters.SubClasificacionTipo = this.selectedSubClasificacionTipo
        if (this.selectedRecomendado) filters.Recomendado = this.selectedRecomendado
        if (this.selectedMunicipio) filters.Municipio = this.selectedMunicipio
        if (this.selectedZona) filters.Zona = this.selectedZona

        this.content.InfotenFilters = filters
        console.log(this.content.InfotenFilters)
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

